module.exports = __webpack_public_path__ + "static/qrcode-3adccbebd6c19e9dd7353b41604987b6.png";